<template>
    <v-layout justify-center wrap id="customer-linked-accounts">
        <v-flex md12>
            <v-layout wrap >
                <v-flex md2 pr-1>
                    <h3 class="headline mb-2">Verknüpfte Konten</h3>
                    <LinkedAccountsActions class="mr-2 mb-2"/>
                </v-flex>
                <v-flex md10 pl-1>
                    <LinkedAccountsOverview />
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout>
</template>

<script>
import LinkedAccountsOverview from '@/components/customer/LinkedAccountsOverview.vue';
import LinkedAccountsActions from '@/components/customer/LinkedAccountsActions.vue';

export default {
    name: 'customer-linked-accounts',
    components: {
        LinkedAccountsOverview,
        LinkedAccountsActions,
    },
};
</script>

<style scoped lang="scss">
</style>
